let HOST = '';

const api = {
    COMMON_INFO: `${HOST}/common/info`,
    NEWS_LIST: `${HOST}/news/list`,
    NEWS_DETAIL: `${HOST}/news/detail`
};

export default api;